export const highlightCurrentNode = (row, column) => {
    const node = document.getElementById(`node-${row}-${column}`);
    node.classList.add("plus");
}

export const unHighlightCurrentNode = (row, column) => {
    const node = document.getElementById(`node-${row}-${column}`);
    node.classList.remove("plus");
}